import RestService from "../RestService";
import REST_URLS from "../RestUrls.constants";

const base = REST_URLS.ACCOUNT.baseUrl;
const endpoints = REST_URLS.ACCOUNT.endpoints;

export default {
  deleteAccount(user) {
    let url = base + endpoints.deleteAccount;
    return RestService.deleteRequest(url, {
      data: {
        user: user
      }
    });
  },

  generateSignupToken(email, access) {
    let url = base + endpoints.generateSignupToken;
    return RestService.postRequest(url, {
      email: email,
      access: access
    });
  },

  getProfile(user) {
    let url = base + endpoints.profile.replace("{user}", user);
    return RestService.getRequest(url);
  },

  getUsers() {
    let url = base + endpoints.users;
    return RestService.postRequest(url);
  },

  getUserEmails() {
    let url = base + endpoints.userEmails;
    return RestService.postRequest(url);
  },

  uploadAvatar(data) {
    let url = base + endpoints.uploadAvatar;
    return RestService.putRequest(url, data);
  }
};
